import { bicCountriesPatterns } from '@/utils/tools/IBAN/BIC.constants';

export function useWalletBicCountry(bic: string): string | undefined {
  const country = Object.keys(bicCountriesPatterns).find((countryPattern) => {
    return new RegExp(`${countryPattern}`).test(bic);
  });

  return country;
}
